import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import _isEmpty from 'lodash/isEmpty';
import GoogleAnalytics from '../../../../services/google-analytics';
import { getBusinessEmailServiceURL } from '../../../../utils/urls';
export function getValidationMessage() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      sections = _ref.sections,
      message = _ref.message;

  if (_isEmpty(sections)) return 'Please select at least one section';
  if (_isEmpty(message)) return 'Please enter a description';
  return '';
}
export function logEvent(step) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      name = _ref2.name;

  GoogleAnalytics.event('Checkout', "Step ".concat(step), {
    label: name
  });
}
export function requestEdit(_x, _x2) {
  return _requestEdit.apply(this, arguments);
}

function _requestEdit() {
  _requestEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3, _ref4) {
    var businessType, businessId, name, email, phone, message, sections, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            businessType = _ref3.type, businessId = _ref3.id;
            name = _ref4.name, email = _ref4.email, phone = _ref4.phone, message = _ref4.message, sections = _ref4.sections;
            url = getBusinessEmailServiceURL(businessType, businessId);
            return _context.abrupt("return", axios.post(url, {
              contact_name: name,
              contact_email: email,
              contact_phone: phone,
              sections: sections,
              message: message,
              email_type: 'publish_banner_request_edit'
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _requestEdit.apply(this, arguments);
}